import { AxiosRequestConfig } from 'axios';

import { BASE_API } from '../utils';

export interface Duplicate {
  skillId: number;
  sourcePositionWithinSkill: number;
  destinationPositionWithinSkill: number;
  // server doesn't need assignmentId, but it is important to Mobius flow
  // this is the 'source' assignment
  assignmentId: number;
}

interface Duplicates {
  destinationAssignmentId: number;
  identifiers: Duplicate[];
  lastUpdated: number;
}

interface DuplicateConfig extends AxiosRequestConfig {
  body: Duplicates;
  data: Duplicates;
  method: 'POST';
  url: `/exams/${string}/locked-problem-copies`;
}

/**
 * Copy locked exam problem(s) from one assignment to another,
 * triggered by teacher clicking ADD PROBLEM on Skill Discovery
 * when a Locked Exam is open on the left side of screen or
 * clicking 'copy' icon on an entire locked exam in Skill Discovery.
 */
export const duplicate = (
  examIdentifier: string,
  identifiers: Duplicate[],
  lastUpdated: number,
): DuplicateConfig => {
  const data = {
    destinationAssignmentId: Number(examIdentifier),
    identifiers,
    lastUpdated,
  };

  return {
    baseURL: BASE_API,
    method: 'POST',
    url: `/exams/${identifiers[0].assignmentId}/locked-problem-copies`,
    body: data,
    data,
  };
};
